// @flow
import { envTypes } from '@atlassiansox/metal-client';
import type { EnvironmentConfig } from 'model/EnvironmentConfig';

export default (): EnvironmentConfig => ({
  atlAdminUrl: 'https://admin.atlassian.com',
  clicktaleEnabled: true,
  hamsUrl: 'https://www.atlassian.com/hamlet',
  idLoginUrl: 'https://id.atlassian.com/login',
  launchdarklyId: '5760d1160b163a072400013d',
  logoutUrl: () =>
    `https://id.atlassian.com/logout?continue=${encodeURIComponent(document.location.href)}`,
  macUrl: 'https://my.atlassian.com',
  marketplaceUrl: 'https://marketplace.atlassian.com',
  padresUrl: 'https://marketplace.atlassian.com/padres',
  paypal: {
    env: 'production',
  },
  segmentKey: 'kiv6wyh2nw',
  sentry: {
    environment: 'prod',
  },
  tnsSessionUrl:
    'https://secure.na.tnspayments.com/form/version/34/merchant/ATLASSIAN02/session.js',
  wacUrl: 'https://www.atlassian.com',
  i18nUrl: 'https://cart-static.us-east-1.prod.public.atl-paas.net/i18n',
  metal: {
    environment: envTypes.PROD,
  },
  cloudMigrationToolsUrl: 'https://api-private.atlassian.com/cloud-migration-tools',
  root: 'https://www.atlassian.com/purchase',
  partnerPortal: 'https://partners.atlassian.com',
  intercomAppID: 'odnoznr4',
  adminHubUrl: 'https://admin.atlassian.com',
  statsigClientSDK: 'client-oDr8m3HJd0tJI9vZAtIlWvV1XpbKPEIJbBBAUGHqtuO',
});
